import React from 'react';
import PropTypes from 'prop-types';
import './TopBar.css';
import { useAuth } from '../context/AuthContext';

export default function TopBar({ toggleSidebar, sidebarOpen }) {
    const { user, handleLogin, handleLogout } = useAuth();

    return (
        <div className={`topbar ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <div className="topbar-left">
                <button
                    className="hamburger"
                    onClick={toggleSidebar}
                    aria-label="Toggle Menu"
                >
                    &#9776;
                </button>
                <input
                    type="text"
                    placeholder="Search for projects"
                    className="search-input"
                />
            </div>

            <div className="topbar-right">
                {user ? (
                    <button onClick={handleLogout} style={{ marginLeft: 'auto', padding: '8px 15px', borderRadius: '5px', border: 'none', backgroundColor: '#dc3545', color: 'white', cursor: 'pointer' }}>
                        Logout ({user.displayName || user.email})
                    </button>
                ) : (
                    <button onClick={handleLogin} style={{ marginLeft: 'auto', padding: '8px 15px', borderRadius: '5px', border: 'none', backgroundColor: '#007bff', color: 'white', cursor: 'pointer' }}>
                        Sign in with Google
                    </button>
                )}
                {user && <span className="username">Hi, {user.displayName || user.email}</span>}
                {user?.photoURL && (
                    <img
                        src={user.photoURL}
                        alt="User Avatar"
                        className="avatar"
                        referrerPolicy="no-referrer"
                    />
                )}
            </div>
        </div>
    );
}

TopBar.propTypes = {
    toggleSidebar: PropTypes.func.isRequired,
    sidebarOpen: PropTypes.bool.isRequired,
};
